var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list.trace_reward_info.reward_image !== '')?_c('div',{staticClass:"Photo",on:{"click":_vm.hClick}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.list.trace_reward_info.reward_image,"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }